<script lang="ts">
  import clsx from 'clsx'
  import withPreventDefault from '../../../../utils/withPreventDefault'

  type Props = {
    colors: string[]
    value: string | undefined
    label: string
  }

  let { colors, value = $bindable(), label }: Props = $props()
</script>

<li class="pl-3 py-2 w-full">
  <div class={clsx('flex flex-col justify-start gap-2 w-full')}>
    <span>{label}</span>
    <div class="flex gap-2">
      {#each colors as color}
        <!-- svelte-ignore a11y_consider_explicit_label -->
        <!-- svelte-ignore element_invalid_self_closing_tag -->
        <button
          onclick={(e) =>
            withPreventDefault(e, () => {
              value = color
            })}
          class="w-5 h-5 rounded-full border border-white/35"
          style={`background-color: ${color};${value === color ? 'border-color: #00000050; box-shadow: 0 0 4px 3px #FFFFFF90' : ''}`}
        />
      {/each}
    </div>
  </div>
</li>
